// loads all the dependencies for code that is used on all pages.
require(["jquery", "underscore", "libs/enquire", "libs/amplify.core"], function ($) {
    // init the global stuff
    require(['global'], function (global) {
        global.init();
    });
});

define("bootstrap", function(){});

